<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@/lib/utils'

import HelpTooltip from '@/components/HelpTooltip.vue'
import Typography from '@/components/ui/typography/Typography.vue'

const props = defineProps<{
  title: string
  tooltip?: string
  titleClass?: HTMLAttributes['class']
}>()
</script>

<template>
  <div class="flex w-full flex-col">
    <div class="mb-[12px] flex items-center gap-1">
      <Typography
        :class="cn('text-text-sub text-xs leading-[20px] font-normal', props.titleClass ?? '')"
      >
        {{ title }}
      </Typography>
      <HelpTooltip v-if="tooltip" class="text-text-soft">{{ tooltip }}</HelpTooltip>
    </div>

    <slot></slot>
  </div>
</template>
